module.exports = __webpack_public_path__ + "img/plus.87150293.svg";